<template>
  <v-dialog v-model="dialog" persistent width="780px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>edit</v-icon> Compensar permiso 
        <v-spacer></v-spacer>
        {{
          horas_disponibles === null
            ? ""
            : `Tiene ${horas_disponibles} horas disponibles`
        }}
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form @submit.prevent="adicionarDetalle()" v-model="valid" ref="form" lazy-validation>
        <v-card-text class="pt-0">
          <v-container grid-list-md class="pt-0">
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete
                  :items="tipo_permisos"
                  item-value="id"
                  item-text="descripcion"
                  v-model="id_permi"
                  label="Solicitar permiso"
                  :rules="$validate(['required'])"
                  required
                  disabled
                />
              </v-flex>
              <!-- <v-flex xs12>
                <v-textarea
                  label="Motivo"
                  v-model="permi_motivo"
                  rows="1"
                  :rules="$validate(['required'])"
                  required
                ></v-textarea>
              </v-flex> -->
            </v-layout>
            <v-layout>
            <v-flex md4 v-if="id_permi == 87">
              <v-text-field
                v-model="permi_lugar"
                label="Comisión a"
                :rules="$validate(['required'])"
                required
                :disabled="permiso_detalles.length > 0"
              />
            </v-flex>
            <v-flex md4 v-if="id_permi == 88 || id_permi==96">
             <p>
              <strong>Total horas a compensar:</strong>
                 {{
                  (
                    $moment(
                      this.permiso.hora_hasta,'hh:mm'
                    ).subtract(
                      this.permiso.hora_desde,'hh:mm'
                      
                    ) 
                  ).format('hh:mm')
                }}
            </p>
            </v-flex>
            </v-layout>

            <v-layout>
              <v-flex md4>
                <v-text-field
                  type="date"
                  v-model="form.fecha_desde"
                  label="Fecha"
                  :rules="$validate(['required'])"
                  required
                  @input="
                    () =>
                      (permisoDetalle.fecha_hasta = permisoDetalle.fecha_desde)
                  "
                />
              </v-flex>

            </v-layout>
            <v-layout>
              <v-flex md4>
                <v-text-field
                  type="time"
                  label="Hora desde"
                  :rules="$validate(['required'])"
                  required
                  v-model="form.hora_desde"
                  :disabled="
                    permiso_detalles.length > 0 &&
                      id_permi.id_tipo_permiso == 87
                  "
                />
              </v-flex>
              <v-flex md4>
                <v-text-field
                  type="time"
                  label="Hora hasta"
                  :rules="$validate(['required'])"
                  required
                  v-model="form.hora_hasta"
                  :disabled="
                    permiso_detalles.length > 0 &&
                      id_permi.id_tipo_permiso == 87
                  "
                />
              </v-flex>
            </v-layout>
           
            <v-layout>
              <v-flex md6>
                <v-spacer></v-spacer>
                <v-btn color="success" block type="submit" :disabled="!valid">
                  <v-icon>arrow_downward</v-icon>
                  Registrar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

         <v-card-text v-if="permiso_detalles.length > 0">
        <v-container>
          <v-layout wrap>
            <v-flex>
              <v-data-table
                :items="permiso_detalles"
                class="elevation-1"
                hide-actions
                :headers="headers"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_hasta).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                 <td class="text-xs-center">{{ props.item.total }} </td>
                  <td class="text-xs-center">{{ props.item.horas_compensa }}</td>
                <!-- <td class="text-xs-center">
                        {{
                  (
                    $moment(
                      props.item.hora_hasta,'hh:mm'
                    ).subtract(
                      props.item.hora_desde,'hh:mm'
                      
                    ) 
                  ).format('hh.mm')
                }}
                  </td>-->
                  <td class="text-xs-center">
                  
                    <v-btn
                      color="error"
                      icon
                      title="Eliminar"
                      @click.prevent="eliminarDetalle()"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>

          <v-layout class="pa-2"
          v-if="horas_solicitadas!=0">
              <v-spacer></v-spacer>

              <v-flex xs3>
                <h4>
                  <strong
                    >Total horas:</strong> {{ horas_solicitadas.toFixed(2) }}
                </h4>
              </v-flex>
            </v-layout>
        </v-container>
      </v-card-text>

      <v-card-text>
        <v-container>
        <!-- <h3 v-if="permiso_compensacion>0"><strong>Detalles compensacion::</strong></h3> -->
        <h3 v-if="permiso_compensacion!=null"><strong>Detalles compensacion ----</strong></h3>
					<v-layout >
						<v-flex xs12>
							
							<v-data-table
									:items="permiso_compensacion"
									class="elevation-1"
									hide-actions
									:headers="headers"
									>
									<template v-slot:items="props">
                    
										<td class="text-xs-center">
										{{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
										</td>
										<td class="text-xs-center">
										{{ $moment(props.item.fecha_hasta).format("DD/MM/YYYY") }}
										</td>
										<td class="text-xs-center">{{ props.item.hora_desde }}</td>
										<td class="text-xs-center">{{ props.item.hora_hasta }}</td> 
                                        <td class="text-xs-center">{{ props.item.diferencia_horas}}</td> 
									<!--	<td class="text-xs-center">
										{{
											(
											$moment(
												props.item.fecha_hasta + " " + props.item.hora_hasta
											).diff(
												props.item.fecha_desde +
												" " +
												props.item.hora_desde,
												"minutes"
											) / 60
											).toFixed(2)
										}}
										</td>-->
                    <td class="text-xs-center">
                    <!-- <v-btn
                      color="info"
                      icon
                      title="Editar"
                      @click.prevent="editarPermisoDetalle(props.item)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn> -->
                    <v-btn
                      color="error"
                      icon
                      title="Eliminar compensacion"
                      @click.prevent="eliminarDetalleCompensa(props.item)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
									</template>
                				</v-data-table>
						</v-flex>
					</v-layout>
					<v-layout class="pa-2">
						<v-flex xs12>
              
						  <h4><strong>Total horas: {{ total_horas_acomuladas }}</strong></h4>
						</v-flex>
					</v-layout>
          </v-container>
      </v-card-text>  
       <v-card-actions class="pr-4">
          <v-spacer></v-spacer>
          <!-- <v-btn color="primary" @click="save()">
            <v-icon>save</v-icon>
            Guardar
          </v-btn> -->

          <v-btn @click.native="close()" color="primary">
            <v-icon>cancel</v-icon>CERRAR
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
import Layout from '@/common/layout/mixins/layout';

export default {
  mixins: [validate],
  props: ["item"],
  mounted() {
          this.form.fecha_desde= null,
          this.form.fecha_hasta= null,
          this.form.hora_desde= null,
          this.form.hora_hasta= null, 
      this.$bus.$on("openDialogCompensarPermisoParticular", item => {
      this.permiso = item;
     
      this.id_permi = item.permiso.id_tipo_permiso;
      this.permi_lugar = item.permiso.lugar;
      this.permi_motivo = item.permiso.motivo;
      this.getPermisoDetalles(item.permiso.id);
      this.verPermisosCompensacion(item.id_permiso);
       this.total_horas();
      this.permiso.motivo = this.permiso.permiso.motivo;
    
      this.dialog = true;
    });
    this.date_formated_fecha_desde = this.$moment(this.date_fecha_desde).format(
      "DD/MM/YYYY"
    );   
    this.obtenerTipoPermiso(); 
  },
  data() {
    return {
        bandera_valida_compensaciones_acomuladas:false,
        total_horas_acomuladas:0, 
        diferencia_de_horas:"",
    lista_compensaciones: [],
      form: {},
      id_permi: "",
      permi_lugar: "",
      permi_motivo: "",

      dialog: false,
      edit: true,
      permiso: {
        id_tipo_permiso: null,
        motivo: "",
        permi_fecha_hasta: "",
        permi_fecha_desde: ""
      },
      permisos: [],
      tipo_permisos: [],
      permiso_compensacion:[], 
      aux: {},
      permiso_detalle: {},

      valid: false,

      date_fecha_desde: "",
      date_formatted_fecha_desde: "",
      menu2_fecha_desde: "",

      date_fecha_hasta: null,
      date_formatted_fecha_hasta: null,
      menu2_fecha_hasta: false,

      // date_fecha_solicitud: null,
      // date_formatted_fecha_solicitud: null,
      // menu2_fecha_solicitud: false,

      time_hora_desde: null,
      menu2_hora_desde: false,
      modal2_hora_desde: false,

      time_hora_hasta: null,
      menu2_hora_hasta: false,
      modal2_hora_hasta: false,
      loading: false,
      headers: [
        
        {
          text: "Fecha salida",
          sortable: false
        },
        {
          text: "Fecha hasta",
          sortable: false
        },
        {
          text: "Hora desde",
          sortable: false
        },
        {
          text: "Hora hasta",
          sortable: false
        },
        {
          text: "Total Horas",
          sortable: false
        },
        {
          text: "Acción",
          sortable: false
        }
      ],
      permiso_detalles: [],
      permisoDetalle: [],
      permiso_detalles_delete: [],
      registro_permiso: false,
      count_id: 0,
      horas_disponibles: null,
      horas_solicitadas: 0,
      horas_solicitadas_comp: 0
    };
  },
  watch: {
    date_fecha_desde(val) {
      this.date_fecha_desde = val;
      this.date_formatted_fecha_desde =
        this.$moment(val).format("DD/MM/YYYY") ||
        this.$moment().format("DD/MM/YYYY");
    },
    date_fecha_hasta(val) {
      this.date_fecha_hasta = val;
      this.date_formatted_fecha_hasta =
        this.$moment(val).format("DD/MM/YYYY") ||
        this.$moment().format("DD/MM/YYYY");
    },
    date_fecha_solicitud(val) {
      this.date_fecha_solicitud = val;
      this.date_formatted_fecha_solicitud =
        this.$moment(val).format("DD/MM/YYYY") ||
        this.$moment().format("DD/MM/YYYY");
    }
  },
  methods: {
      async verPermisosCompensacion(id_permiso) {
        
        try {
           
         let respuesta = await this.$service.graphql({
       
                            query: `
                               query{
                                    runQuery(consulta:"select * from control.fn_permiso_compensa_datos(${id_permiso}) AS datos"){
                                  respuesta
                                }
                            }
                            `
                            })
                           
                            this.permiso_compensacion = respuesta.runQuery.respuesta;
                           
        
      } catch (error) {
        console.log(error);
      }
    },
      async horaMayorQue(){
        try {
              let hora_limite=  (
                    this.$moment(
                      this.permiso.hora_hasta,'hh:mm'
                    ).subtract(
                      this.permiso.hora_desde,'hh:mm'
                      
                    ) 
                  ).format('hh:mm')
                  
                       if(this.total_horas_acomuladas!=0){
                           
                       this.total_horas_acomuladas='00:00'
                       this.bandera_valida_compensaciones_acomuladas=true
                 
                        } 
                       else{
                            let respuesta = await this.$service.graphql({
       
                            query: `
                                query{
                                runQuery(consulta:"select control.fn_mayor_dos_horas('${this.total_horas_acomuladas}','${hora_limite}')"){
                                    respuesta
                                }
                                }	

                            `
                            })
                            let resp=respuesta.runQuery.respuesta[0].fn_mayor_dos_horas
                            
                       }
           
             
           
          } catch (error) {
              console.log(error)
          }
      },
     async total_horas(){
         try {
              let respuesta = await this.$service.graphql({
             
            query: `
                query{
                  runQuery(consulta:"select control.fn_total_horas_compensacion(${this.permiso.id_permiso})"){
                    respuesta
                  }
                }	

              `
          })
          if (respuesta.runQuery.respuesta[0].fn_total_horas_compensacion==null || respuesta.runQuery.respuesta[0].fn_total_horas_compensacion==undefined) {
              this.total_horas_acomuladas=0
          } else {
              
          }
          let resp=respuesta.runQuery.respuesta[0].fn_total_horas_compensacion
          this.total_horas_acomuladas=resp
        
         } catch (error) {
             console.log(error)
         }
     },
   
    async adicionarDetalle() {
      try {
         if (this.$refs.form.validate()) {
          let dif_horas
           let respuesta 
            const temp = {
          fecha_desde: this.form.fecha_desde,
          fecha_hasta: this.form.fecha_desde,
          hora_desde: this.form.hora_desde,
          hora_hasta: this.form.hora_hasta,
          index: this.count_id++
        };
              respuesta = await this.$service.graphql({
             
            query: `
                 query{
                              runQuery(consulta:"select control.fn_diferencia_horas('${temp.hora_desde}','${temp.hora_hasta}')"){
                                respuesta
                              }
                            }
              `
          })
          dif_horas = respuesta.runQuery.respuesta[0].fn_diferencia_horas;
           
         temp.total=dif_horas
    
        let user = this.$storage.get("user");
        let id_funcionario = user.id;
         let correcto 
         let horas_debe
        //aqui va la funcion de validar el permiso:
       
       
         respuesta = await this.$service.graphql({
             
            query: `
                 query{
                              runQuery(consulta:"select control.fn_valida_compensacion(${this.permiso.id_permiso},'${temp.fecha_desde}','${temp.fecha_hasta}','${temp.hora_desde}','${temp.hora_hasta}',${id_funcionario})"){
                                respuesta
                              }
                            }
              `
          })
                let res = respuesta.runQuery.respuesta[0].fn_valida_compensacion;
                let  resps = res.split('|');
                correcto = resps[0];
              
                if (correcto === "1") {
                     
                     let user = this.$storage.get("user");
                    let id = user.id;
                     let permisodet = {
                    id_permiso_detalle: parseInt(this.permisoDetalle.id_permiso),
                    fecha_desde: this.permiso_detalles.fecha_desde,
                    fecha_hasta: this.permiso_detalles.fecha_desde,
                    hora_desde: this.permiso_detalles.hora_desde,
                    hora_hasta: this.permiso_detalles.hora_hasta,
                    id_funcionario: id
                    };    
                    await this.horaMayorQue();
                    respuesta = await this.$service.graphql({
                    
                    query: `
                        query{
                        runQuery(consulta:"select control.fn_registra_compensacion(${permisodet.id_permiso_detalle},'${temp.fecha_desde}','${temp.fecha_hasta}','${temp.hora_desde}','${temp.hora_hasta}', ${permisodet.id_funcionario})"){
                            respuesta
                        }
                        }	

                    `
                    })
                  
                  
                    let resp2=respuesta.runQuery.respuesta[0].fn_registra_compensacion
                    let resps2 = resp2.split('|');
                    let correcto2 = resps2[0]; 
                    //console.log("ppppp",resps2)
                    if (correcto2  === "1") {
                         this.total_horas();
                        this.verPermisosCompensacion(permisodet.id_permiso_detalle)
                         
                        this.$message.success("Registro exitoso.");
                        
                    } else {
                        this.$message.error(resps2);
                    }
                  
                }else{
                 
                    console.log(resps)
                        this.$message.error(resps);
                  
               }
               this.form={}
      }
      } catch (error) {
        console.log(error)
      }
    },
    eliminarDetalle() {
      if (this.$refs.form.validate()) {
        const temp = {
          fecha_desde: null,
          fecha_hasta: null,
          hora_desde: null,
          hora_hasta: null,
          index: null
        };
        this.permiso_detalles.shift(temp);
        this.valid = true;
        //this.sumar_horas();
        this.$message.success("Detalle Eliminado");
      }
    },
    async eliminarDetalleCompensa(item) {
       
       
      try {
         let respuesta = await this.$service.graphql({
             
            query: `
                query{
                  runQuery(consulta:"select control.fn_elimina_compensacion(${item.id_permiso_compensa})"){
                    respuesta
                  }
                }	
              `
          })
       
       
         // this.total_horas();
          let respuesta2 = respuesta.runQuery.respuesta[0].fn_elimina_compensacion;
                      let resps = respuesta2.split('|');
                      let correcto = resps[0];
                     
                        if (correcto === "1") {
                            this.$message.warning(resps[1])
                        }
        this.verPermisosCompensacion(this.permiso.id_permiso)

         /*  let respuesta = await this.$service.graphql({
             
            query: `
                query{
                  runQuery(consulta:"delete from control.permiso_compensacion where id=${item.id}"){
                    respuesta
                  }
                }	

              `
          })*/

        
        //  location.reload();

        } catch (error) {
          console.log(error);
        }


    },
   
    async obtenerTipoPermiso() {
      try {
        let response = await this.$service.graphql({
          query: `
            query {
							tipoPermisos(id_estado: 19,id_parametro_elaborado:91) {
                rows {
                  id
                  descripcion
                  refrigerio
                  tiempo_maximo
                  tiempo_minimo
                  estado {
                    descripcion
                    abrev
                  }
                }
              }
            }
          `
        });
        this.tipo_permisos = response.tipoPermisos.rows;
      } catch (error) {
        console.log(error);
      }

    },

    async getPermisoDetalles(id_permiso) {
      let response = await this.$service.graphql({
        query: `
                query{
                  permisoDetalles(id_permiso:${id_permiso}){
                    rows{
                      id
                      id_permiso
                      fecha_desde
                      fecha_hasta
                      hora_desde
                      hora_hasta
                    }
                  }
                }
        		`
      });
      if (response) {
        this.permisoDetalle = response.permisoDetalles.rows[0];
      }
    },
    validarPermiso() {
      const user = this.$storage.get("user");
      this.$service
        .graphql({
          query: `
          query {
						controlPermisoValidate(id_persona: ${user.id_persona}, fecha_solicitud: "${this.date_fecha_desde}", id_tipo_permiso: ${this.permiso.id_tipo_permiso}){
							horas
						}
				}
        `
        })
        .then(response => {
          if (response) {
            this.horas_disponibles = response.controlPermisoValidate.horas;
            this.horas_disponibles += this.horas_solicitadas;
            this.edit = false;
          }
        });
    },
    close() {
      this.dialog = false;
      this.permiso = {
        id_tipo_permiso: null,
        motivo: ""
      };
      this.date_fecha_desde = null;
      this.date_fecha_hasta = null;
      this.time_hora_desde = null;
      this.time_hora_hasta = null;
      this.permiso_detalles = [];
      this.count_id = 0;
      this.horas_disponibles = null;
      this.horas_solicitadas = 0;
      this.edit = true;
      this.permiso_detalles_delete = [];
      this.$bus.$emit("closeDialog");
    },
    addPermisoDetalle() {
       let total=0;
      
      if (this.$refs.form.validate()) {
        this.edit = false;
        this.loading = true;
        
        if (fecha_temp > 0) {
          this.permiso_detalle.fecha_desde = this.date_fecha_desde;
          this.permiso_detalle.fecha_hasta = this.date_fecha_desde;
          this.permiso_detalle.hora_desde = this.time_hora_desde;
          this.permiso_detalle.hora_hasta = this.time_hora_hasta;
          this.permiso_detalle.id_estado = 17;
          this.permiso_detalle.delete = this.count_id++;
          this.permiso_detalles.push(this.permiso_detalle);
          //this.sumar_horas();
          this.permiso_detalle = {};
          this.$message.success("Detalle agregado");
          this.registro_permiso = true;
          (this.date_fecha_desde = new Date().toISOString().substr(0, 10)),
            (this.date_fecha_hasta = new Date().toISOString().substr(0, 10)),
            (this.time_hora_desde = null);
          this.time_hora_hasta = null;
         
        } else {
          this.$message.error(
            "Las fechas y horas no son correctas, revise por favor"
          );
        }
        this.loading = false;
      }
    },
    deletePermisoDetalle(id) {
      let tempList = this.permiso_detalles;
      for (let i = 0; i <= tempList.length; i++) {
        if (tempList[i].id === id) {
          tempList.splice(i, 1);
          break;
        }
      }
      this.permiso_detalles = tempList;
      //this.sumar_horas();
      this.$message.warning("Detalle eliminado");
    },
    /* sumar_horas() {
           let total = 0;
            let permisodet = {
            id_permiso_detalle: parseInt(this.permisoDetalle.id_permiso),
            fecha_desde: this.permisoDetalles.fecha_desde,
            fecha_hasta: this.permisoDetalles.fecha_hasta,
            hora_desde: this.permisoDetalles.hora_desde,
            hora_hasta: this.permisoDetalles.hora_hasta,
            id_funcionario: id
            };    

          respuesta = await this.$service.graphql({
             
            query: `
                query{
                  runQuery(consulta:"select control.fn_registra_compensacion(${permisodet.id_permiso_detalle},'${permisodet.fecha_desde}','${permisodet.fecha_hasta}','${permisodet.hora_desde}','${permisodet.hora_hasta}', ${permisodet.id_funcionario})"){
                    respuesta
                  }
                }	

              `
          })
       
       
          let resp=respuesta.runQuery.respuesta[0].fn_registra_compensacion
          let resps = resp.split('|');
          let correcto = resps[0]; 
 

        if (correcto === '1') {
           this.$confirm("Registro exitoso", () => {
                         
                            });
        } else {
          this.$confirm(resps[1] , () => {
                         
                            });
        }
       
              this.permiso_detalles.forEach(item => {
        total +=
          this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
            item.fecha_desde + " " + item.hora_desde,
            "minutes"
          ) / 60;
            });
           
    },*/
    sumar_horas_compensa(permiso_detalles) {
      
      	let total_comp = 0;
      	permiso_detalles.forEach((item) => {
        total_comp +=
          this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
            item.fecha_desde + " " + item.hora_desde,
            "minutes"
          ) / 60;
      	});
		
      	this.horas_solicitadas_comp = total_comp;
   		},
     editarPermisoDetalle(item) {
      this.id_tipo_permi=this.form.id_tipo_permiso
      this.$bus.$emit("editarDetalle", item, this.id_tipo_permi);
    
    
    },
    async save() {
     
        let respuesta;
        let user = this.$storage.get("user");
        let id_persona = user.id_persona;
        let id = user.id;

        let fechita = this.$moment(this.permiso.permiso.fecha_permiso).format(
          "DD/MM/YYYY"
        );
        let permisocab = {
          id_permiso: parseInt(this.permiso.id_permiso),
          motivo: this.permi_motivo,
          fecha_permiso: fechita,
          lugar: this.permi_lugar,

          id_funcionario: parseInt(id)
        };


        let fecha2 = this.$moment(this.permisoDetalle.fecha_desde).format(
          "DD/MM/YYYY"
        );
        let fecha3 = this.$moment(this.permisoDetalle.fecha_hasta).format(
          "DD/MM/YYYY"
        );
       
       
        let permisodet = {
          id_permiso_detalle: parseInt(this.permisoDetalle.id_permiso),
          fecha_desde: fecha2,
          fecha_hasta: fecha2,
          hora_desde: this.permisoDetalle.hora_desde,
          hora_hasta: this.permisoDetalle.hora_hasta,
          id_funcionario: id
        };

     
        try {
            
          this.permiso_detalles.forEach(async item => {
            let permisodet = {
            id_permiso_detalle: parseInt(this.permisoDetalle.id_permiso),
            fecha_desde: item.fecha_desde,
            fecha_hasta: item.fecha_hasta,
            hora_desde: item.hora_desde,
            hora_hasta: item.hora_hasta,
            id_funcionario: id
            };    

          respuesta = await this.$service.graphql({
             
            query: `
                query{
                  runQuery(consulta:"select control.fn_registra_compensacion(${permisodet.id_permiso_detalle},'${permisodet.fecha_desde}','${permisodet.fecha_hasta}','${permisodet.hora_desde}','${permisodet.hora_hasta}', ${permisodet.id_funcionario})"){
                    respuesta
                  }
                }	

              `
          })
      
          let resp=respuesta.runQuery.respuesta[0].fn_registra_compensacion
          let resps = resp.split('|');
          let correcto = resps[0]; 
    
        if (correcto === '1') {
           this.$confirm("Registro exitoso", () => {
                         
                            });
        } else {
          this.$confirm(resps[1] , () => {
                         
                            });
        }
         })
        
        } catch (error) {
          console.log(error);
        }
      //}
     
          this.form.fecha_desde= null,
          this.form.fecha_hasta= null,
          this.form.hora_desde= null,
          this.form.hora_hasta= null,
          this.close();
    }
  },
  
  

  registerPermisoDetalle(id) {
    this.permiso_detalles_delete.forEach(async item => {
      await this.$service
        .graphql({
          query: `
						mutation remove($id: ID!) {
							permisoDetalleDelete(id: $id) {
								deleted
							}
						}
					`,
          variables: { id: item }
        })
        .then(response => {
        
        });
    });
    this.permiso_detalles.forEach(async item => {
      item.id_permiso = id;
      item.id_estado = 17;
      delete item.id;
      delete item.delete;
      await this.$service
        .graphql({
          query: `
						mutation add($permisoDetalle: NewPermisoDetalle!) {
							permisoDetalleAdd(permisoDetalle: $permisoDetalle) {
								id
							}
						}
					`,
          variables: {
            permisoDetalle: item
          }
        })
        .then(responsePermisoDetalle => {
    
        });
    });
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/CompensarPermisoParticular.vue